import { createStyles, makeStyles } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

type Props = {
  mode?: 'lightModeOnly';
};
export const useStyles = (styleProps: Props) =>
  makeStyles((theme) =>
    createStyles({
      root: {
        boxShadow: `0 0 5px 0px ${COLORS.PRIMARY}`,
        background: 'transparent',
        border: '1px solid',
        borderColor:
          theme.palette.type === 'dark'
            ? styleProps.mode === 'lightModeOnly'
              ? COLORS.LIGHT_BORDER
              : COLORS.DARK_BORDER
            : COLORS.LIGHT_BORDER,
        borderRadius: 5,
        display: 'flex',
        alignItems: 'center',
        height: 30,
        padding: 5,
        gap: 10,

        '& svg': {
          height: 16,
          width: 'auto',
        },
      },
    }),
  );
